import errorMessage from '@rendes/error-message';
window.errorMessage   = errorMessage;

import MessageBox from '@rendes/message-box';
window.MessageBox     = MessageBox;